import React, { useEffect, useState } from "react";
import E_EnergyConsumption from './e_energy_consumption/e_energy_consumption';
import E_HighestUsageDays from './e_highest_usage_days/e_highest-usage-days';
import E_MeterReads from './e_meter_reads/e_meter_reads';
import E_UsageComparison from './e_usage_comparison/e_usage_comparison';
const Components = {
    E_EnergyConsumption,
    E_HighestUsageDays,
    E_MeterReads,
    E_UsageComparison
  };
   
  export default block => {
    if (typeof Components[block.widgetName] !== "undefined") {
      return React.createElement(Components[block.widgetName], {
        block: block
      });
    }
  }